// @flow

export const GET_CAMPAIGN: 'get_campaign' = 'get_campaign';

export type Action =
  | {
  type:typeof GET_CAMPAIGN,
  campaign: {}
}
  ;